import { defineStore } from 'pinia';
import Vue from 'vue';

export const useReportsStore = defineStore('reports', {
    state: () => ({
        datasetGroups: {},
        errors: {}
    }),

    actions: {
        // Former mutations
        addReports(payload) {
            if (payload[0] && payload[1]) {
                Vue.set(this.datasetGroups, ...payload);
            }
        },
        addErrors(payload) {
            if (payload[0]) {
                Vue.set(this.errors, ...payload);
            }
        }
    }
});
